import { render } from "./CurrentUserMixin.vue?vue&type=template&id=5988232b"
import script from "./CurrentUserMixin.vue?vue&type=script&lang=js"
export * from "./CurrentUserMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__